import { EventEmitter, Injectable, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { RouteInfo } from './rds-sidebar.metadata';

@Injectable({
	providedIn: 'root'
})
export class RdsSidebarService {

	sideBarEmitter = new EventEmitter();
	menuItems: RouteInfo[] = [];

	@Output() miniSidebar: EventEmitter<string> = new EventEmitter();
	@Output() changeMenu: EventEmitter<RouteInfo[]> = new EventEmitter();

	setMenuItems(lstNewMenuItems: RouteInfo[]) {
		this.menuItems = lstNewMenuItems;
		this.changeMenu.emit(this.menuItems);
	}
}
